import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, Row, Image, Button, Col } from "react-bootstrap";
import LeftSideNavigation from "../../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../navigationSection/BottomNavigationMobile";
import { TopNavigationBarMobile } from "../../../navigationSection/TopNavigationBarMobile";
import AddRsvpEvent from "./AddRsvpEvent";
import AddRsvpTicketBooking from "./AddRsvpTicketBooking";
import moment from "moment";
import Media from "react-media";
import Switch from "react-switch";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { get_single_rsvp_event_information } from "../../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import { vendor_update_events } from "../../../../../store/actions/vendorOffersAndEventsAction";
import isEmpty from "../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";

const AddRsvpTicketBooked = (props) => {
  let location = useLocation();
  let history = useHistory();
  const [selectedPage, setSelectedPage] = useState(1);
  const [editPageRequest, setEditPageRequest] = useState("");
  const onPageChange = (value) => (e) => {
    setSelectedPage(value);
  };
  const [editAction, setEditAction] = useState(false);
  const [editGeustUserData, setEeditGeustUserData] = useState({});

  useEffect(() => {
    if (history?.location?.state?.defaultPage === "TICKET_BOOKED") {
      setSelectedPage(2);
      setEditPageRequest("TICKET_BOOKED");
    } else if (history?.location?.state?.defaultPage === "RSVP") {
      setSelectedPage(1);
      setEditPageRequest("RSVP");
    } else {
      setSelectedPage(1);
      setEditPageRequest("RSVP/TICKET");
    }
  }, [history?.location?.state?.defaultPage]);

  useEffect(() => {
    if (history?.location?.state?.actionBy === "EDIT_ACTION") {
      setEditAction(true);
    } else {
      setEditAction(false);
    }
  }, [history?.location?.state?.actionBy]);

  useEffect(() => {
    setEeditGeustUserData(history?.location?.state?.editGuestInfo);
  }, [history?.location?.state?.editGuestInfo]);

  const [eventId, setEventId] = useState();
  const [getSingleEventInfo, setGetSingleEventInfo] = useState({});

  useEffect(() => {
    setEventId(props?.getSingleEventInfo?._id);
    props.get_single_rsvp_event_information(
      props?.getSingleEventInfo?._id,
      props.auth.user.accessToken
    );
  }, [location, selectedPage]);

  useEffect(() => {
    setGetSingleEventInfo(props.getSingleEventInfo);
  }, [props.getSingleEventInfo]);

  const onBackButtonClick = (e) => {
    history.push({
      pathname: `/offline-events-details/${props?.getSingleEventInfo?._id}`,
      state: { offlineEventInformation: props?.getSingleEventInfo?._id },
    });
  };

  const onClickBookingClosed = (e, data) => {
    const token = props.auth.user.accessToken;
    const eventId = data._id;
    const formData = {
      booking_closed: data.booking_closed === true ? false : true,
    };
    props.vendor_update_events(formData, eventId, token, (e) =>
      onSuccessRsvp(e)
    );
  };

  const onSuccessRsvp = (e) => {
    Alert.success("<h4>Booking Closed Updated Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    props.get_single_rsvp_event_information(
      location.state.addGuestInfo,
      props.auth.user.accessToken
    );
  };

  if (props.auth.loader) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                actionPerform="button"
                backButtonLink={onBackButtonClick}
                displayText="Back"
              />
              <div className="f24_700_HelveticaNeue py-3 px-2">
                {editAction ? "Edit Guest" : "Add Guest"}
              </div>
              <Row className="px-2">
                <Col md={3}>
                  <span className="f16-500" style={{ fontWeight: "bold" }}>
                    {getSingleEventInfo.name}
                  </span>
                  <span
                    className="badge badge-warning ml-2 f8-500 text-white"
                    style={{ padding: "5px 15px", borderRadius: 12 }}
                  >
                    {getSingleEventInfo.isOnline ? "Online" : "Offline"}
                  </span>
                  <br />
                  <span className="f12-400" style={{ color: "#EE3A23" }}>
                    Event ID: {getSingleEventInfo.event_id}
                  </span>
                  {/* <br />
                  <span className="f9-400" style={{ color: "#9E9E9E" }}>
                    These imply that the net payment is due in either 7, 10, 30,
                    60, or 90 days after the ... invoice date.
                  </span> */}
                </Col>
                <Col md={3}>
                  {!editAction ? (
                    <div className="d-flex align-items-center">
                      <p className="f16-500 pr-3">Booking Closed</p>
                      <div className="d-flex align-items-center py-4 pl-md-4">
                        <div
                          className={`${
                            getSingleEventInfo?.booking_closed
                              ? "f11-400 mr-2"
                              : "f11-500 mr-2"
                          }`}
                        >
                          No
                        </div>
                        <Switch
                          onChange={(e) =>
                            onClickBookingClosed(e, getSingleEventInfo)
                          }
                          // disabled={true}
                          checked={getSingleEventInfo?.booking_closed}
                          offColor="#E0E0E0"
                          onColor="#E0E0E0"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                        <div
                          className={`${
                            getSingleEventInfo?.booking_closed
                              ? "f11-500 ml-2"
                              : "f11-400 ml-2"
                          }`}
                        >
                          Yes
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
                <Col md={3}>
                  <div className="row">
                    <div className="col-6 col-sm-6 col-md-6">
                      <h5 className="f10-500 text-gray">
                        Event Start Time / Date
                      </h5>
                      <p className="f14-700">
                        {moment(getSingleEventInfo.start_date).format(
                          "Do MMM, YYYY hh:mm A"
                        )}
                      </p>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6">
                      <h5 className="f10-500 text-gray">
                        Event End Time / Date
                      </h5>
                      <p className="f14-700">
                        {moment(getSingleEventInfo.end_date).format(
                          "Do MMM, YYYY hh:mm A"
                        )}
                      </p>
                    </div>
                  </div>
                </Col>
                {/* <Col md={3} className="py-2">
                  <div className="row">
                    
                  </div>
                </Col> */}
              </Row>
              <hr />
              <div className="d-flex align-items-start">
                {editPageRequest === "RSVP" ? (
                  <>
                    {selectedPage === 1 ? (
                      <Button
                        variant="link"
                        className={`enAddOffersOPtion d-flex flex-column align-items-center mr-5  text-center ${
                          selectedPage === 1 ? "active" : ""
                        }`}
                        onClick={onPageChange(1)}
                      >
                        <Image
                          src={
                            selectedPage === 1
                              ? require("../../../../../assets/images/ActionImages/1/walkActive.svg")
                              : require("../../../../../assets/images/ActionImages/1/walk.svg")
                          }
                          alt="View"
                          title="View"
                          fluid
                        />
                        <span className="active f12-400 d-block w-100 mb-2">
                          RSVP
                        </span>
                      </Button>
                    ) : null}
                  </>
                ) : editPageRequest === "TICKET_BOOKED" ? (
                  <>
                    {props.getSingleEventInfo?.ticket_booking_subscription ? (
                      <Button
                        variant="link"
                        className={`enAddOffersOPtion d-flex flex-column align-items-center ml-3 text-center ${
                          selectedPage === 2 ? "active" : ""
                        }`}
                        onClick={onPageChange(2)}
                      >
                        <Image
                          src={
                            selectedPage === 2
                              ? require("../../../../../assets/images/ActionImages/1/ReservationsActive.svg")
                              : require("../../../../../assets/images/ActionImages/1/Reservations.svg")
                          }
                          alt="View"
                          title="View"
                          fluid
                        />
                        <span className="active f12-400 d-block w-100 mb-2">
                          Booked Ticket
                        </span>
                      </Button>
                    ) : null}
                  </>
                ) : (
                  <>
                    {selectedPage === 1 ? (
                      <Button
                        variant="link"
                        className={`enAddOffersOPtion d-flex flex-column align-items-center mr-5  text-center ${
                          selectedPage === 1 ? "active" : ""
                        }`}
                        onClick={onPageChange(1)}
                      >
                        <Image
                          src={
                            selectedPage === 1
                              ? require("../../../../../assets/images/ActionImages/1/walkActive.svg")
                              : require("../../../../../assets/images/ActionImages/1/walk.svg")
                          }
                          alt="View"
                          title="View"
                          fluid
                        />
                        <span className="active f12-400 d-block w-100 mb-2">
                          RSVP
                        </span>
                      </Button>
                    ) : null}
                    {props.getSingleEventInfo?.ticket_booking_subscription ? (
                      <Button
                        variant="link"
                        className={`enAddOffersOPtion d-flex flex-column align-items-center ml-3 text-center ${
                          selectedPage === 2 ? "active" : ""
                        }`}
                        onClick={onPageChange(2)}
                      >
                        <Image
                          src={
                            selectedPage === 2
                              ? require("../../../../../assets/images/ActionImages/1/ReservationsActive.svg")
                              : require("../../../../../assets/images/ActionImages/1/Reservations.svg")
                          }
                          alt="View"
                          title="View"
                          fluid
                        />
                        <span className="active f12-400 d-block w-100 mb-2">
                          Booked Ticket
                        </span>
                      </Button>
                    ) : null}
                  </>
                )}
              </div>
              <hr />
              {selectedPage === 1 && (
                <AddRsvpEvent
                  eventInfo={getSingleEventInfo}
                  editAction={editAction}
                  editGeustUserData={editGeustUserData}
                />
              )}
              {selectedPage === 2 && (
                <AddRsvpTicketBooking
                  eventInfo={getSingleEventInfo}
                  editAction={editAction}
                  editGeustUserData={editGeustUserData}
                />
              )}
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
};

AddRsvpTicketBooked.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  get_single_rsvp_event_information: PropTypes.func.isRequired,
  vendor_update_events: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  getSingleEventInfo: state.rsvpEvent?.get_single_event_info,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .event_management &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .event_management.offline_event &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .event_management.offline_event,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_single_rsvp_event_information,
  vendor_update_events,
})(withRouter(AddRsvpTicketBooked));
